export default __webpack_public_path__ + "fonts/list_1.2acb4e7a2eba6054649be31b51ceaf87.png";